import React, {Component} from 'react';

import axios from 'axios';

import APIGatewayClientProvider, {APIGatewayClientContext} from '../provider/APIGatewayClientProvider';
import NotFound404 from '../error/NotFound404';
import DataLoading from '../homepage/DataLoading';

const IS_WORK_VIEW_ENABLED_KEY = 'isWorkViewEnabled';

/**
 * Route guard that only renders the wrapped component if the work view
 * feature flag is enabled for the current warehouse. Renders 404 otherwise.
 */
export default function WorkViewRouteGuard(WrappedComponent) {
    class WorkViewGuard extends Component {

        static contextType = APIGatewayClientContext;

        constructor(props) {
            super(props);
            this.state = {
                isLoading: true,
                isWorkViewEnabled: false
            };
            this.cancelTokenSource = APIGatewayClientProvider.createNewCancelTokenSource();
        }

        componentDidMount() {
            this.checkFeatureFlag();
        }

        componentWillUnmount() {
            this.cancelTokenSource.cancel('Unmounting WorkViewRouteGuard, cancelling work-view feature-flag fetch');
        }

        componentDidUpdate(prevProps) {
            const prevWarehouseId = prevProps.match.params.warehouseId;
            const currentWarehouseId = this.props.match.params.warehouseId;
            if (prevWarehouseId !== currentWarehouseId) {
                this.checkFeatureFlag();
            }
        }

        checkFeatureFlag() {
            const warehouseId = this.props.match.params.warehouseId;
            if (!warehouseId) {
                this.setState({isLoading: false, isWorkViewEnabled: false});
                return;
            }
            // Cancel any in-flight request before starting a new one so an earlier warehouse's
            // response can't resolve after (and overwrite) a newer one, and so a pending request
            // is cancelled on unmount rather than calling setState on an unmounted component.
            this.cancelTokenSource.cancel('Superseded by a newer work-view feature-flag fetch');
            this.cancelTokenSource = APIGatewayClientProvider.createNewCancelTokenSource();
            this.setState({isLoading: true});
            this.context.client.getCustomConfigurationsByWarehouseId(warehouseId, this.cancelTokenSource.token)
                .then(response => {
                    const configurations = response.data.warehouseCustomConfigurations;
                    const isWorkViewEnabled = configurations && configurations[IS_WORK_VIEW_ENABLED_KEY] === 'true';
                    this.setState({isLoading: false, isWorkViewEnabled});
                })
                .catch(error => {
                    if (!axios.isCancel(error)) {
                        this.setState({isLoading: false, isWorkViewEnabled: false});
                    }
                });
        }

        render() {
            if (this.state.isLoading) {
                return <DataLoading/>;
            }
            if (!this.state.isWorkViewEnabled) {
                return <NotFound404/>;
            }
            return <WrappedComponent {...this.props}/>;
        }
    }

    return WorkViewGuard;
}
